import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseURL from "../../config";
import axios from "axios";

const badgeStyle = {
  m: 0.5,
  fontWeight: "bold",
};

const SignOffModal = ({ signoffDetails = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = signoffDetails.filter((item) => {
    const vesselName = item?.contract?.vesselName || "";
    const crewName = item?.contract?.crewName || "";
    return (
      vesselName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      crewName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const handleFileUpload = async (file, item) => {
    if (!file || !item) return;

    const formData = new FormData();
    formData.append("ssDocument", file);
    formData.append("crewid", item?.contract?.crewdetails?._id || "");
    formData.append("crewinagentId", item?.contract?.crewingAgent || "");
    formData.append("contractId", item?.contract?._id || "");
    formData.append("crewName", item?.contract?.crewName || "");
    formData.append("type", "signoff");

    try {
      const token = localStorage.getItem("token"); // Or however you store your JWT token

      const response = await axios.post(
        `${baseURL}/api/crewingAgent/ssDocumentsForCrewSignOnSignOff`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Include token here
          },
        }
      );

      toast.success("Document uploaded successfully!");
      // console.log(response.data);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      const message =
        error.response?.data?.error || "An error occurred during file upload.";
      toast.error(message);
      console.error("Upload error:", error);
    }
  };

  return (
    <Box sx={{ mt: 5, px: 2 }}>
      <Paper
        elevation={3}
        sx={{
          p: 1,
          bgcolor: "#C30B12",
          color: "white",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <TextField
          placeholder="Search by Vessel Name or Crew"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: "280px",
          }}
        />

        <Typography
          variant="h6"
          sx={{
            mx: "auto",
            textAlign: "center",
            flex: 1,
            fontWeight: "bold",
            color: "#f5f5f5",
          }}
        >
          SignOff Details
        </Typography>

        <Box sx={{ width: 300 }} /> {/* Spacer for layout symmetry */}
      </Paper>

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Sr. No.</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No matching COC data found.
                </TableCell>
              </TableRow>
            ) : (
              filteredData.map((item, index) => {
                const signOffDate = item?.data?.date
                  ? new Date(item.data.date).toLocaleDateString("en-GB")
                  : "N/A";

                return (
                  <TableRow key={item._id || index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">
                        Vessel Name: {item?.contract?.vesselName || "N/A"}
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                        <Chip label={`Crew: ${item?.contract?.crewName || "N/A"}`} color="primary" sx={badgeStyle} />
                        <Chip
                          label={`Indos No.: ${item?.contract?.crewdetails?.indosno || "N/A"}`}
                          sx={{ ...badgeStyle, backgroundColor: "#ffeb3b", color: "#000" }}
                        />

                        <Chip
                          label={`SignOff Date: ${signOffDate}`}
                          sx={{ ...badgeStyle, backgroundColor: "#ffe0b2", color: "#e65100" }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      {item?.ssDocumentRecords?.[0]?.signoff?.[0]?.ssDocument?.filePath ? (
                        <Tooltip title="SS Document" arrow placement="top">
                          <IconButton
                            href={`${baseURL}/${item.ssDocumentRecords[0].signoff[0].ssDocument.filePath.replace(/\\/g, "/")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                          >
                            <PictureAsPdfIcon sx={{ color: "green" }} />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Upload Screenshot" arrow placement="top">
                          <IconButton
                            component="label"
                            size="small"
                          >
                            <input
                              type="file"
                              accept="application/pdf"
                              hidden
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleFileUpload(file, item);
                                }
                                e.target.value = null;
                              }}
                            />
                            <CloudUploadIcon sx={{ color: "#757575" }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Paper>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default SignOffModal;
